// 活动直播
import { useEffect, useMemo } from 'react';
import classNames from 'classnames';
import useLiveEventHooks from './LiveEventHooks';
import { RootObject, Content8, ContentBlock, TimeContent } from '../../type';
import './style.less';


const LiveEvent = (props: RootObject["liveEvent"]) => {
    const {
        zhTitle,
        enTitle,
        content
    } = props;
    const {
        selectedTabKey,
        isFirstLoad,
        setSelectedTabKey
    } = useLiveEventHooks();
    const showList: any = useMemo(() => {
        const findItem = content.find(item => item.title === selectedTabKey);
        if (findItem) {
            return findItem.contentBlock;
        }
        return [];
    }, [content, selectedTabKey]);

    useEffect(() => {
        if (isFirstLoad.current && !selectedTabKey && content.length > 0) {
            isFirstLoad.current = false;
            setSelectedTabKey(content[0].title);
        }
    }, [selectedTabKey, content, isFirstLoad, setSelectedTabKey]);
    return (
        <div className='p-p-foundathon-liveEvent-wrapper'>
            <div className='p-p-foundathon-liveEvent'>
                <div className='p-p-foundathon-liveEvent-zh-title'>
                    {
                        zhTitle ?? ''
                    }
                </div>
                <div className='p-p-foundathon-liveEvent-en-title'>
                    {
                        enTitle ?? ''
                    }
                </div>
                {/* tabs内容 */}
                <div>
                    {/* tabs内容 */}
                    <div className="p-p-foundathon-liveEvent-modules clear-both">
                        <div className="p-p-foundathon-liveEvent-modules-menu">
                            {content.map((tab: Content8) => (
                                <div
                                    key={tab.title}
                                    className={classNames(
                                        'p-p-foundathon-liveEvent-modules-menu-item',
                                        { 'p-p-foundathon-liveEvent-modules-menu-item-selected': tab.title === selectedTabKey }
                                    )}
                                    onClick={() => setSelectedTabKey(tab.title)}
                                    onMouseEnter={() => setSelectedTabKey(tab.title)}
                                >
                                    <div className='p-p-foundathon-liveEvent-modules-menu-item-title'>
                                        {
                                            tab.title ?? ''
                                        }
                                    </div>
                                    <div className='p-p-foundathon-liveEvent-modules-menu-item-title-desc'>
                                        <div className='p-p-foundathon-liveEvent-modules-menu-item-title-desc-title'>
                                            {
                                                tab.intro ?? ''
                                            }
                                        </div>
                                        <div className='p-p-foundathon-liveEvent-modules-menu-item-title-desc-line'>
                                        </div>
                                        <div className='p-p-foundathon-liveEvent-modules-menu-item-title-desc-txt'>
                                            {
                                                tab.desc ?? ''
                                            }
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="p-p-foundathon-liveEvent-modules-body">
                            <div className="p-p-foundathon-liveEvent-modules-body-item">
                                {
                                    showList.map((item: ContentBlock, index: number) => {
                                        return (
                                            <div className='p-p-foundathon-liveEvent-modules-body-item-content' key={index}>
                                                <img src={item.img} alt="" className='p-p-foundathon-liveEvent-modules-body-item-content-img'/>
                                                <div className='p-p-foundathon-liveEvent-modules-body-item-content-heade'>
                                                    {
                                                        item.title ?? ''
                                                    }
                                                </div>
                                                <div className='p-p-foundathon-liveEvent-modules-body-item-content-list'>
                                                    {
                                                        item.descList.map((el: TimeContent, i: number) => {
                                                            return (
                                                                <div className='p-p-foundathon-liveEvent-modules-body-item-content-list-txt' key={i}>
                                                                    <div className='p-p-foundathon-liveEvent-modules-body-item-content-list-txt-title'>
                                                                        {
                                                                            el.title ?? ''
                                                                        }
                                                                    </div>
                                                                    <div className='p-p-foundathon-liveEvent-modules-body-item-content-list-txt-desc'>
                                                                        {
                                                                            el.desc ?? ''
                                                                        }
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                                {
                                                    item.desc.split('$').map(ele => <div className='p-p-foundathon-liveEvent-modules-body-item-content-desc'>
                                                        {ele}
                                                    </div>)
                                                }
                                                
                                                <div className='p-p-foundathon-liveEvent-modules-body-item-content-btn'>
                                                    <a href={item.skip.skipLink} target='_blank' rel='noreferrer'>
                                                        {
                                                            item.skip.skipName ?? ''
                                                        }
                                                    </a>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LiveEvent;